import axios from "axios";
import config from "../config";

const _serverUrl = `${config.URL_SERVER}`;

const api = axios.create({
  baseURL: _serverUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
    "Access-Control-Expose-Headers": "*",
  },
});

const BizinBackend = {
  async loginUser(email, password, _csrf) {
    const url = `${_serverUrl}/login`;
    const data = {
      _csrf,
      email,
      password
    };
    try {
      const response = await api.post(url, data);
      if (response?.data?.data)
        return {
          ...response.data.data,
          access_token: response.data.access_token,
        };
    } catch (error) {
      return { message: error?.response?.data?.message || error.message };
    }
  },

  async loginUserByToken(email, token, _csrf) {
    const url = `${_serverUrl}/login-token`;
    const data = {
      _csrf,
      email,
      token,
    };

    const response = (await api.post(url, data)).data;

    if (response.data)
      return { ...response.data, access_token: response.access_token };
    else return;
  },

  async executeProcedure(prm, proc, _csrf, access_token_msman) {
    const url = `${_serverUrl}/execute-procedure`;
    const data = {
      requestData: prm,
      proc,
    };
    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": _csrf,
      "X-Access-Token-Msman": access_token_msman,
    };
    let response;

    try {
      response = (await api.post(url, data, { headers }))?.data;
    } catch (error) {
      response = {
        code: error?.code,
        status: error?.response?.status || error?.status,
        statusText: error?.response?.statusText || error?.message,
        procName: proc,
        procParams: prm,
        responseBackend: error?.response?.data?.response,
      };
      if (error?.status === 401 && localStorage.getItem("render_in_iframe"))
        window.location.href = `/logout`;
      console.log("error: ", response);
    }

    return response?.data || response;
  },

  async executeSuperInsights({ promptIA, token }) {
    const url = `${_serverUrl}/perguntar`;
    const data = {
      promptIA: promptIA,
    };
    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    };

    const resp = await api.post(url, data, { headers });

    // Retorna a resposta diretamente, mesmo se for string vazia
    return resp.data !== undefined ? resp.data : "";
  },
  async fileUpload({
    fileName,
    extension,
    crop,
    fileBase64,
    _csrf,
    access_token_msman,
  }) {
    const url = `${_serverUrl}/file-upload`;

    const data = { fileName, extension, crop, fileBase64 };

    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": _csrf,
      "X-Access-Token-Msman": access_token_msman,
    };

    const response = await api.post(url, data, { headers });

    return response.data;
  },

  async checkAccessToken(access_token) {
    const url = `/check-access-token`;
    return await api.post(url, { _ac_token: access_token });
  },

  async getCsrfToken() {
    const response = await api.get("/_get_csrf_token");
    return response.data;
  },
};

export default BizinBackend;
